import './App.css';
import {useRoutes} from 'react-router-dom'
import router from './router'

function App() {
  return (
    <div style={{width:'100%',height:'100%'}}>
            {useRoutes(router)}
    </div>
  );
}

export default App;
